import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { AnnouncementBar } from './components/AnnouncementBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Language + translation blocking (Spanish - Latin America)
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'MEGAPACK Funcional 365 — Todo tu año de funcional, listo';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'MEGAPACK Funcional 365: 6 Tomos, 365 sesiones, 5 bonos estratégicos. Todo tu año de clases de funcional, listo desde hoy por 17 USD. Pagas en tu moneda local.'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#020617'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: 'https://cdn.magicpatterns.com/uploads/a5wDcjcYkyBHi6BisQcSi3/MOCKUP_PNG.png',
      // @ts-ignore
      fetchpriority: 'high'
    });
    // Performance: warm up the checkout connection so CTA clicks navigate
    // instantly. TCP + TLS happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://megapack-funcional-365.impultienda.ar'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://megapack-funcional-365.impultienda.ar',
      crossorigin: ''
    });
    // Performance: open the pixel connection early
    ensureLink({
      rel: 'preconnect',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="es-419" translate="no" className="notranslate min-h-screen bg-slate-950 font-sans text-slate-300 selection:bg-sky-400 selection:text-slate-950" data-id="element-0" data-mp="6o5xls1ln0mf">
      <MetaPixel data-id="element-1" data-mp="qwvrie5a2n6d" />
      <SocialProofPopup data-id="element-2" data-mp="qxf5xkvpytfn" />
      <ExitIntentModal data-id="element-3" data-mp="qyq9pkp6016r" />
      <StickyMobileCTA data-id="element-4" data-mp="qyyoxj8rfil4" />
      <AnnouncementBar data-id="element-5" data-mp="m6p2id6ut0nl" />
      <Hero data-id="element-6" data-mp="m5dz4ehblux0" />
      <SocialProof data-id="element-7" data-mp="m5ngxes7ovrm" />
      <Testimonials1 data-id="element-8" data-mp="m544uep8t1li" />
      <Problem data-id="element-9" data-mp="h7c5izm9qd7a" />
      <ProductTomos data-id="element-10" data-mp="h6sy4cu8v77i" />
      <Bonuses data-id="element-11" data-mp="h8drw08qim4b" />
      <UrgencyCounter data-id="element-12" data-mp="h7vnggbx51lb" />
      <Pricing data-id="element-13" data-mp="h59jeqo8l47u" />
      <Testimonials2 data-id="element-14" data-mp="c89cyenh5zg7" />
      <Guarantee data-id="element-15" data-mp="c8rdhnh66ztx" />
      <FAQ data-id="element-16" data-mp="c9aqcpryqy13" />
      <CostOfNotHaving data-id="element-17" data-mp="c9u5jyq8b8bf" />
      <FinalCTA data-id="element-18" data-mp="c66ed689axzv" />
      <Footer data-id="element-19" data-mp="19vzyzih688vx" />
    </div>;
}